import BaseToggleSwitch from "./BaseToggleSwitch.vue";

export default BaseToggleSwitch;
